<template>
  <div class="flex flex-col">
    <div class="flex w-full flex-col items-start gap-4">
      <div class="flex w-full flex-col gap-0.5">
        <h3 class="text-title-medium">Skills</h3>
        <MenonChart
          :skill-analysis="allSkills"
          :max-value="scale.items.length"
          :topic-perspectives="topicPerspectives"
          :fix-width="300"
          background-color="surface-container-lowest"
        />
      </div>
      <div class="grid w-full grid-cols-2 gap-4">
        <PrintFinalQuestionSection
          class="grow basis-0"
          :questions="strengths"
          :topic-perspectives="topicPerspectives"
          :title="$t('dialog.evaluation.slide.strengths')"
        />
        <PrintFinalQuestionSection
          class="grow basis-0"
          :questions="potentials"
          :topic-perspectives="topicPerspectives"
          :title="$t('dialog.evaluation.slide.potentials')"
        />
        <PrintFinalQuestionSection
          class="grow basis-0"
          :questions="overestimates"
          :topic-perspectives="topicPerspectives"
          :title="$t('dialog.evaluation.slide.overestimates')"
        />
        <PrintFinalQuestionSection
          class="grow basis-0"
          :questions="underestimates"
          :topic-perspectives="topicPerspectives"
          :title="$t('dialog.evaluation.slide.underestimates')"
        />
      </div>
      <div class="flex w-full grow flex-col gap-4 lg:flex-row">
        <PrintFinalTextFeedbacks class="grow basis-0" :texts="texts" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { FeedbackTopic } from '@/core/models/feedback-topic'
  import type { Scale } from '@/core/models/scale'
  import MenonChart from '@/core/components/analytics/menon-chart/MenonChart.vue'
  import type { Skill } from '@/core/models/skill'
  import type {
    QuestionAnalysis,
    SkillAnalysis,
    TextAnalysis,
  } from '@/core/models/surveys-analytics'
  import { useSkillAnalysis } from '@/core/composables/use-skill-analysis'
  import PrintFinalTextFeedbacks from './PrintFinalTextFeedbacks.vue'
  import PrintFinalQuestionSection from './PrintFinalQuestionSection.vue'
  import { computed } from 'vue'
  import { perspectivesFromTopic } from '@/core/models/perspective'
  interface Props {
    feedbackTopic: FeedbackTopic & { skills: ReadonlyArray<Skill> }
    skillData: ReadonlyArray<SkillAnalysis>
    strengths: ReadonlyArray<QuestionAnalysis>
    potentials: ReadonlyArray<QuestionAnalysis>
    overestimates: ReadonlyArray<QuestionAnalysis>
    underestimates: ReadonlyArray<QuestionAnalysis>
    texts: ReadonlyArray<TextAnalysis>
    scale: Scale
  }

  const props = defineProps<Props>()
  const { allSkills } = useSkillAnalysis(props.skillData)
  const topicPerspectives = computed(() => perspectivesFromTopic(props.feedbackTopic))
</script>
